import {
    // addUserWidgetsAction,
    getUserWidgetsAction,
} from "../userWidgetsAction";
import $api from "../../../../../services/axiosService";
// import ExperienceControlService from "../../../../../../frontend.services/Profile/ExperienceControlService";

import moment from "moment";

export const userWidgetsThunkAction = () => async (dispatch) => {
    try {
        const widgets = [];

        const division = await $api.get("/v1.0/c/u/6");
        const mainAppointment = await $api.get("/v1.0/c/u/12");
        const pid = $api.defaults.headers.common["pid"];
        const tabNum = pid ? division.data.data.appointment.find(el => el.pid == pid) : mainAppointment.data.data.appointment[0];
        const tabelNumber = {
            title: "Табельный номер",
            description: tabNum
                ? `${tabNum.tabNumber}`
                : "---",
        };
        widgets.push(tabelNumber);
        const upcomingLeaves = await $api("v1/p/po/leaves/upcoming");
        const upcomingEvent = {
            title: "Предстоящий отпуск",
            description: upcomingLeaves.data.from
                ? `${moment(upcomingLeaves.data.from).format("DD.MM.YYYY")} 
                - ${moment(upcomingLeaves.data.to).format("DD.MM.YYYY")} `
                : "Отсутствует",
        };
        widgets.push(upcomingEvent);

        dispatch(getUserWidgetsAction(widgets));
    } catch (e) {
        // throw new Error("ERROR WHILE GETTING USER WIDGETS");
    }
};
